import BaseListPage from "../../../../base/BaseListPage";
import PageContainer from "../../../../components/PageContainer/PageContainer";
import Progress from "../../../../components/Progress";
import Table from "../../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import withRouter from "../../../../utils/withRouter";
import DefaultState from "./components/DefaultState";
import FilterGenerator from "./components/filterGenerator";
import NoResultState from "./components/NoResultState";
import NoResultState2 from "./components/NoResultState2";
import SamePrintButton from "./components/SamePrintButton";
import NegativeRecordsListPresenter from "./NegativeRecordsListPresenter";

class NagativeRecordsListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.state = {
      objects: [],
      selected: [],
      loading: false,
      total: 0,
      count: 0,
      searchedName: "",
      searchLog: {},
      searchStatus: "default",
      searchBtnDisabled: false,
      outSideClient: [],
      userAffBranch: [],
      userLoggedin: [],
      filterWhere: {},
    };
    this.presenter = new NegativeRecordsListPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      upsertUseCase(),
      deleteObjectUseCase(),
    );

    this.fieldsToDisplay = ["lastName", "middleName", "firstName", "alias"];
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }

  getCollectionName() {
    return "records";
  }

  onClickView(index) {
    this.presenter.onClickView(index);
  }

  setSearchedName(name) {
    this.setState({ searchedName: name });
  }

  setSearchStatus(status) {
    this.setState({ searchStatus: status });
  }

  setSearchLog(log) {
    this.setState({ searchLog: log });
  }

  searchSubmit(where, merge) {
    const trimmedWhere = Object.entries(where).reduce((acc, [key, value]) => {
      acc[key] =
        typeof value === "string" ? value.trim().replace(/\s+/g, " ") : value;
      return acc;
    }, {});

    this.setState({ filterWhere: trimmedWhere });
    this.setState({ searchBtnDisabled: true });
    this.presenter.searchSubmit(trimmedWhere, merge);
  }
  // searchSubmit(where, merge) {
  //   console.log("Where", where);
  //   // Trim trailing spaces from all string values
  //   const trimmedWhere = Object.entries(where).reduce((acc, [key, value]) => {
  //     acc[key] = typeof value === "string" ? value.trimEnd() : value;
  //     return acc;
  //   }, {});

  //   // console.log("where", trimmedWhere);
  //   this.setState({ filterWhere: trimmedWhere });
  //   this.setState({ searchBtnDisabled: true });
  //   // this.presenter.searchSubmit(trimmedWhere, merge);
  // }

  // filterObjects(objects) {
  //   const uniqueNames = new Set();
  //   const filterdObjects = objects.filter((item) => {
  //     const uniqueKey = `${item.firstName}-${item.middleName}-${item.lastName}-${item.alias}`;

  //     if (!uniqueNames.has(uniqueKey)) {
  //       uniqueNames.add(uniqueKey);
  //       return true;
  //     }
  //     return false;
  //   });

  //   return filterdObjects;
  // }

  getActions() {
    return [
      {
        label: "View",
        onClick: this.onClickView.bind(this),
        icon: "bi bi-eye",
      },
    ];
  }

  formatObjects(arr) {
    if (!Array.isArray(arr) || arr.length === 0) return [];

    return arr.map(
      ({
        searched_last_name,
        searched_first_name,
        searched_middle_name,
        ...rest
      }) => ({
        // original fields
        searched_last_name,
        searched_first_name,
        searched_middle_name,

        // formatted (camelCase) aliases
        lastName: searched_last_name,
        firstName: searched_first_name,
        middleName: searched_middle_name,

        // any other props you might have on each object
        ...rest,
      }),
    );
  }

  onClickSaveNoRecord(search) {
    this.presenter.onClickSaveNoRecord(search);
  }

  setOutSideClient(response) {
    this.setState({ outSideClient: response });
  }

  setUserAffBranch(user) {
    this.setState({ userAffBranch: user });
  }

  setUser(response) {
    this.setState({ userLoggedin: response });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const user = this.getCurrentUser();

    const {
      objects,
      loading,
      count,
      searchLog,
      searchStatus,
      outSideClient,
      userAffBranch,
      userLoggedin,
      filterWhere,
    } = this.state;
    const formattedObjects = this.formatObjects(objects);

    // const show2 = objects.some((obj) => {
    //   const firstNameMatch = obj.firstName === filterWhere.firstName;
    //   const lastNameMatch = obj.lastName === filterWhere.lastName;

    //   let middleNameMatch;

    //   if (filterWhere.middleName === "" || !filterWhere.middleName) {
    //     // If filterWhere has no middleName, check if object also has no middleName
    //     middleNameMatch = obj.middleName === "" || !obj.middleName;
    //   } else {
    //     // If filterWhere has middleName, check for exact match
    //     middleNameMatch = obj.middleName === filterWhere.middleName;
    //   }

    //   return firstNameMatch && middleNameMatch && lastNameMatch;
    // });
    const show2 = objects.some((obj) => {
      const firstNameMatch = obj.firstName === filterWhere.firstName;
      const lastNameMatch = obj.lastName === filterWhere.lastName;

      let middleNameMatch;

      if (filterWhere.middleName === "" || !filterWhere.middleName) {
        // If filterWhere has no middleName, check if object also has no middleName
        middleNameMatch = obj.middleName === "" || !obj.middleName;
      } else {
        // If filterWhere has middleName, check for exact match
        middleNameMatch = obj.middleName === filterWhere.middleName;
      }

      let aliasMatch;

      if (filterWhere.alias === "" || !filterWhere.alias) {
        // If filterWhere has no alias, check if object also has no alias
        aliasMatch = obj.alias === "" || !obj.alias;
      } else {
        // If filterWhere has alias, check for exact match
        aliasMatch = obj.alias === filterWhere.alias;
      }

      return firstNameMatch && middleNameMatch && lastNameMatch && aliasMatch;
    });
    // console.log("show2", show2);

    // console.log("objects", objects);
    // console.log("schema", schema);

    const outside = outSideClient.map((out) => out.name);

    const financeCompanies = outside;

    const userName = userAffBranch?.[0]?.affiliate?.name;

    const isFinance = financeCompanies.includes(userName);

    // console.log("isFiance", isFinance);
    // console.log("userLoggedin", userLoggedin);

    return (
      <PageContainer
        title="Negative Records Simple Search"
        infiniteScroll={{
          loadMore: this.loadMore.bind(this),
          hasMore: !loading && count > objects.length,
        }}
      >
        <FilterGenerator
          schema={schema}
          onSubmit={this.searchSubmit.bind(this)}
          searchBtnDisabled={this.state.searchBtnDisabled}
        />

        {/* <SamePrintButton
          searchLog={searchLog}
          user={user}
          onClickSaveNoRecord={this.onClickSaveNoRecord.bind(this)}
        /> */}

        {loading ? (
          <div className="h-100 w-100 d-flex justify-content-center align-items-center">
            <Progress />
          </div>
        ) : objects.length < 1 && searchStatus !== "searched" ? (
          <DefaultState />
        ) : objects.length < 1 ? (
          <NoResultState
            searchLog={searchLog}
            user={user}
            onClickSaveNoRecord={this.onClickSaveNoRecord.bind(this)}
            isFinances={isFinance}
            userLoggedin={userLoggedin}
          />
        ) : (
          <>
            <Table
              fields={schema.fields}
              // objects={this.filterObjects(objects)}
              // objects={formattedObjects}
              objects={objects}
              d
              collapsable
              actions={this.getActions.bind(this)}
              progress={loading}
              excludeFields={Object.keys(schema.fields).filter(
                (key) => !this.fieldsToDisplay.includes(key),
              )}
            />
            {!show2 && (
              <NoResultState2
                searchLog={searchLog}
                user={user}
                onClickSaveNoRecord={this.onClickSaveNoRecord.bind(this)}
                isFinances={isFinance}
                userLoggedin={userLoggedin}
              />
            )}
          </>
        )}
      </PageContainer>
    );
  }
}

export default withRouter(NagativeRecordsListPage);
